import React from 'react';
import { Carousel } from 'antd';

const premiereImageContext = require.context(
  '../../../../Assets/Linkages/SpaceOutreachFilm/PremiereAtIST',
  false,
  /\.jpg$/i,
);

const premiereImages = premiereImageContext.keys().sort().map((key) => {
  const image = premiereImageContext(key);
  return image.default || image;
});

const PremiereAtIST = () => (
  <section className="film-premiere" aria-labelledby="film-premiere-title">
    <div className="film-premiere-inner">
      <header className="film-premiere-header">
        <p className="section-eyebrow">A LANDMARK IN SCIENCE COMMUNICATION</p>
        <h2 id="film-premiere-title">Premiere at IST</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>

      <p className="film-premiere-copy">
        Pakistan’s first space-science telefilm on climate change, Jahan Aur Bhi Hain — Beyond the
        Blue, premiered at the Institute of Space Technology (IST), Islamabad on May 30, 2025.
        Merging cinematic storytelling with scientific insight, the film sets a powerful precedent
        for creative science communication. Produced by the National Center of GIS and Space
        Applications (NCGSA)—a joint initiative of the Higher Education Commission and the Ministry
        of Planning, Development &amp; Special Initiatives—and co-produced with Beaconhouse National
        University, LockDown Productions, and Filmbaily.
      </p>

      <Carousel
        className="film-premiere-carousel"
        autoplay
        autoplaySpeed={2000}
        pauseOnHover
        dots
        slidesToShow={3}
        slidesToScroll={1}
        responsive={[
          { breakpoint: 1050, settings: { slidesToShow: 2 } },
          { breakpoint: 680, settings: { slidesToShow: 1 } },
        ]}
      >
        {premiereImages.map((src, index) => (
          <div className="film-premiere-slide" key={src}>
            <figure>
              <img src={src} alt={`Jahan Aur Bhi Hain premiere at IST ${index + 1}`} loading="lazy" />
            </figure>
          </div>
        ))}
      </Carousel>
    </div>
  </section>
);

export default PremiereAtIST;
